document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.swatch');
  if (!swatch) return;

  const variantId = swatch.dataset.variantId;
  if (!variantId) return;

  const diffuserItem = swatch.closest('.diffuser-item');
  if (!diffuserItem) return;

  const imgEl = diffuserItem.querySelector('.difuser-image img');
  if (!imgEl) return;

  const variantImage = swatch.getAttribute('data-variant-image');
  if (variantImage) {
    imgEl.src = variantImage;
    imgEl.srcset = variantImage;
  }

  diffuserItem.querySelectorAll('.swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion-heading').forEach(heading => {
    heading.addEventListener('click', function () {
      const accordion = this.parentElement;
      const content = accordion.querySelector('.accordion-content');
      const icon = this.querySelector('.accordion-icon');
      const isOpen = accordion.classList.contains('active');

      document.querySelectorAll('.accordion.active').forEach(item => {
        if (item !== accordion) {
          const c = item.querySelector('.accordion-content');
          c.style.height = c.scrollHeight + 'px';
          requestAnimationFrame(() => { c.style.height = '0px'; });
          item.classList.remove('active');
          item.querySelector('.accordion-icon').textContent = '+';
        }
      });

      if (!isOpen) {
        accordion.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        icon.textContent = '−';
      } else {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => { content.style.height = '0px'; });
        accordion.classList.remove('active');
        icon.textContent = '+';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  async function enforceStarterBundleGift() {
    if (window.STARTER_BUNDLE_HIDE_GIFT) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      let hasBundleDiffuser = false;
      let hasBundleScent = false;
      let giftLineKey = null;

      cart.items.forEach(item => {
        if (item.properties && item.properties._starter_bundle === 'true') {
          if (item.properties._free_scent === 'Starter Kit') {
            hasBundleScent = true;
          } else {
            hasBundleDiffuser = true;
          }
        }
        if (item.variant_id === FREE_GIFT_VARIANT_ID) {
          giftLineKey = item.key;
        }
      });

      if (hasBundleDiffuser && hasBundleScent && !giftLineKey) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: FREE_GIFT_VARIANT_ID,
            quantity: 1,
            properties: { _starter_bundle_gift: 'true' }
          })
        });
      }

      if ((!hasBundleDiffuser || !hasBundleScent) && giftLineKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLineKey, quantity: 0 })
        });
      }
    } catch (e) {
      console.error('Starter bundle gift error', e);
    }
  }

  enforceStarterBundleGift();
  document.addEventListener('cart:refresh', enforceStarterBundleGift);

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (
      target.closest('.rebuy-cart__flyout-item-remove') ||
      target.closest('.rebuy-cart__flyout-item-quantity-widget-button')
    ) {
      setTimeout(enforceStarterBundleGift, 500);
    }
  });

  // ── State ──────────────────────────────────────────────
  let selectedDiffuserVariant = null;
  let selectedDiffuserVariantTitle = null;
  let selectedScentVariant = null;
  let isAddingToCart = false;
  let selectedScentSellingPlan = null;
  let diffuserConfirmed = false;
  let selectedDiffuserPrice = 0;
  let selectedScentPrice = 0;

  // ── DOM refs ───────────────────────────────────────────
  const rightPart       = document.querySelector('.right-part');
  const toggle          = document.querySelector('.mobile-accordion-toggle');
  const addToCartBtn    = document.querySelector('.whole-atc');
  const step1Container  = document.querySelector('.starter-diffuser-step1');
  const step2Container  = document.querySelector('.starter-diffuser-step2');
  const nextStepBtn     = document.querySelector('.next-step-btn');
  const step1title      = document.querySelector('.step1-title');
  const prevStepBtn     = document.querySelector('.prev-step-btn');

  const diffuserSummaryItem = document.querySelector('.summary-diffuser');
  const scentSummaryItem    = document.querySelector('.summary-scent');
  const diffuserContent     = diffuserSummaryItem.querySelector('.summary-content');
  const diffuserMeta        = diffuserSummaryItem.querySelector('.summary-meta');
  const scentContent        = scentSummaryItem.querySelector('.summary-content');
  const scentMeta           = scentSummaryItem.querySelector('.summary-meta');

   // ── Breadcrumb refs ────────────────────────────────────
  const breadcrumbWrappers = document.querySelectorAll('.step-breadcrumb-wrapper');
  const breadcrumbScent    = document.querySelector('.breadcrumb-scent');

function setStep(stepNumber) {
  breadcrumbWrappers.forEach(wrapper => {
    wrapper.classList.remove('step-2-entered');
    if (stepNumber === 1) {
      wrapper.classList.add('step-1-active');
      wrapper.classList.remove('step-2-active');
    } else {
      wrapper.classList.add('step-2-active');
      wrapper.classList.remove('step-1-active');
    }
  });
}

  // ── Mobile accordion ───────────────────────────────────
  if (rightPart && toggle) {
    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      rightPart.classList.toggle('open');
      document.body.style.overflow = rightPart.classList.contains('open') ? 'hidden' : '';
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        rightPart.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  // ── Helpers ────────────────────────────────────────────
  function updateAddToCartState() {
    if (diffuserConfirmed && selectedScentVariant) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('disabled');
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
    }
  }

  function updateBundleCount() {
    let count = 0;
    if (selectedDiffuserVariant) count++;
    if (selectedScentVariant) count++;

    const bundleTitle = document.querySelector('.Bundle-selec span');
    if (!bundleTitle) return;
    bundleTitle.childNodes[0].nodeValue = `${count}/2 Selected `;
  }
  function updateProgressBar() {
  const width = diffuserConfirmed && selectedScentVariant ? '100%'
              : diffuserConfirmed ? '50%'
              : '0%';
  document.querySelectorAll('.progress-fill').forEach(fill => {
    fill.style.width = width;
  });
}

  function updateTotalKitPrice() {
    const totalWrap  = document.querySelector('.total-kit-price');
    if (!totalWrap) return;

    const newPriceEl   = totalWrap.querySelector('.new-price');
    const totalPriceEl = totalWrap.querySelector('.price');

    if (!selectedScentVariant) {
      totalWrap.style.display = 'none';
      return;
    }

    const compareAt = selectedDiffuserPrice + selectedScentPrice;
    totalWrap.style.display = 'block';

    if (newPriceEl) newPriceEl.innerHTML = `$${selectedDiffuserPrice.toFixed(2)}`;
    if (totalPriceEl) {
      totalPriceEl.innerHTML = `
        <span class="today">$${selectedDiffuserPrice.toFixed(2)}</span>
        <span class="compare-at">$${compareAt.toFixed(2)}</span>
      `;
    }
  }

  function updateBundlePreview() {
    const diffuserImg   = diffuserSummaryItem.querySelector('img');
    const scentImg      = scentSummaryItem.querySelector('img');
    const previewDiffuser = document.querySelector('.preview-diffuser');
    const previewScent    = document.querySelector('.preview-scent');
    if (!previewDiffuser || !previewScent) return;
    previewDiffuser.innerHTML = diffuserImg ? `<img src="${diffuserImg.src}" alt="">` : '';
    previewScent.innerHTML    = scentImg    ? `<img src="${scentImg.src}" alt="">`    : '';
  }

  updateAddToCartState();

  // ── Auto-select first diffuser swatch ─────────────────
  function autoSelectFirstDiffuserSwatch() {
    document.querySelectorAll('.diffuser-item').forEach(diffuserItem => {
      const firstSwatch = diffuserItem.querySelector('.variant-swatches .swatch:not(.is-soldout)');
      if (!firstSwatch) return;

      firstSwatch.classList.add('active');
      diffuserItem.dataset.selectedVariantId    = firstSwatch.dataset.variantId;
      diffuserItem.dataset.selectedVariantTitle = firstSwatch.getAttribute('aria-label');

      selectedDiffuserVariant      = firstSwatch.dataset.variantId;
      selectedDiffuserVariantTitle = firstSwatch.getAttribute('aria-label');

      const imageEl = diffuserItem.querySelector('.difuser-image img');
      if (imageEl && firstSwatch.dataset.variantImage) {
        imageEl.src    = firstSwatch.dataset.variantImage;
        imageEl.srcset = firstSwatch.dataset.variantImage;
      }
    });
  }

  autoSelectFirstDiffuserSwatch();
  // Disable + button for any diffuser whose auto-selected swatch is OOS
document.querySelectorAll('.diffuser-item').forEach(item => {
  const selectedId = item.dataset.selectedVariantId;
  const selectedSwatch = item.querySelector(`.swatch[data-variant-id="${selectedId}"]`);
  const addBtn = item.querySelector('.diffuser-add-btn');
  if (addBtn && selectedSwatch && selectedSwatch.classList.contains('is-soldout')) {
    addBtn.disabled = true;
  }
});
  updateProgressBar();

  // Make entire diffuser card clickable
document.querySelectorAll('.diffuser-item').forEach(item => {
  item.addEventListener('click', function (e) {
    if (e.target.closest('.variant-swatches')) return;
    if (e.target.closest('.diffuser-add-btn')) return;

    const btn = item.querySelector('.diffuser-add-btn');
    if (btn && !btn.disabled && !btn.classList.contains('is-soldout')) {
      btn.click();
    }
  });
});

// Make entire scent card clickable
document.querySelectorAll('.scent-item').forEach(item => {
  item.addEventListener('click', function (e) {
    if (e.target.closest('.button')) return;

    const btn = item.querySelector('.button');
    if (btn && !btn.disabled && !btn.classList.contains('is-soldout')) {
      btn.click();
    }
  });
});

  // ── Diffuser swatch click ──────────────────────────────
  document.querySelectorAll('.variant-swatches .swatch').forEach(swatch => {
    swatch.addEventListener('click', function () {
      const diffuserItem = this.closest('.diffuser-item');
      diffuserItem.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      diffuserItem.dataset.selectedVariantId    = this.dataset.variantId;
      diffuserItem.dataset.selectedVariantTitle = this.getAttribute('aria-label');

      const imgEl = diffuserItem.querySelector('.difuser-image img');
      if (imgEl && this.dataset.variantImage) {
        imgEl.src    = this.dataset.variantImage;
        imgEl.srcset = this.dataset.variantImage;
      }

      // Disable/enable + button based on selected swatch availability
      const addBtn = diffuserItem.querySelector('.diffuser-add-btn');
      if (addBtn && !addBtn.classList.contains('is-soldout')) {
        addBtn.disabled = this.classList.contains('is-soldout');
      }

      // Re-confirm only if available
      if (diffuserItem.classList.contains('is-dselected') && !this.classList.contains('is-soldout')) {
        if (addBtn && !addBtn.classList.contains('is-soldout')) {
          addBtn.click();
        }
      }
    });
  });

  // ── Enable Next when diffuser button clicked ───────────
  document.querySelectorAll('.diffuser-add-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      if (!btn.classList.contains('is-soldout')) {
        nextStepBtn.disabled = false;
      }
    });
  });

  // ── Step navigation helpers ────────────────────────────
 function showStep1() {
  step2Container.classList.add('is-hidden');
  step1Container.classList.remove('is-hidden');
  step1title.classList.remove('is-hidden');
  nextStepBtn.classList.remove('is-hidden');
  setStep(1); // also removes step-2-entered via updated setStep below
}

  function showStep2() {
  step1Container.classList.add('is-hidden');
  step1title.classList.add('is-hidden');
  nextStepBtn.classList.add('is-hidden');
  step2Container.classList.remove('is-hidden');

  breadcrumbWrappers.forEach(wrapper => {
    wrapper.classList.remove('step-1-active');
    wrapper.classList.add('step-2-entered');
  });
}

  // ── Next button ────────────────────────────────────────
  nextStepBtn.addEventListener('click', function () {
    if (!selectedDiffuserVariant) {
      alert('Please select a diffuser before continuing.');
      return;
    }
    showStep2();
  });

  // ── Scent breadcrumb click ─────────────────────────────
  breadcrumbScent.addEventListener('click', function () {
    if (!selectedDiffuserVariant) {
      alert('Please select a diffuser first.');
      return;
    }
    showStep2();
  });

  // ── Back to step 1 ─────────────────────────────────────
  function goBackToStep1() {
    showStep1();
    autoSelectFirstDiffuserSwatch();
  }

  document.querySelectorAll('.back-to-step1').forEach(el => {
    el.addEventListener('click', goBackToStep1);
  });

  diffuserSummaryItem.querySelector('.summary-remove')
    .addEventListener('click', goBackToStep1);

  if (prevStepBtn) {
    prevStepBtn.addEventListener('click', function () {
      showStep1();
      step1Container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ── Diffuser confirm ───────────────────────────────────
  document.querySelectorAll('.diffuser-item .diffuser-add-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const diffuserItem        = this.closest('.diffuser-item');
      const selectedVariantId   = diffuserItem.dataset.selectedVariantId;
      const selectedVariantTitle = diffuserItem.dataset.selectedVariantTitle;

      if (!selectedVariantId) {
        alert('Please select a diffuser variant');
        return;
      }

      diffuserConfirmed = true;

      document.querySelectorAll('.diffuser-item').forEach(item => item.classList.remove('is-dselected'));

      document.querySelectorAll('.diffuser-add-btn').forEach(b => {
        if (!b.classList.contains('is-soldout')) {
          b.classList.remove('is-selected');
          b.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1629/7465/files/Button.svg?v=1779944609">`;
        }
      });

      this.classList.add('is-selected');
      diffuserItem.classList.add('is-dselected');
      this.textContent = 'Selected';

      const price        = diffuserItem.querySelector('p').innerText;
      const variantImage = diffuserItem.querySelector(`.variant-swatches .swatch[data-variant-id="${selectedVariantId}"]`)?.dataset.variantImage || diffuserItem.dataset.image;
      const ratingHtml        = diffuserItem.querySelector('.rating-badge')?.outerHTML || '';
      const diffuserDescription = diffuserItem.querySelector('.dfi-cont')?.innerHTML || '';

      diffuserContent.innerHTML = `<img src="${variantImage}" alt="${diffuserItem.dataset.title}">`;
      diffuserMeta.innerHTML = `
        <h4>${diffuserItem.dataset.title}</h4>
        ${ratingHtml}
        <div class="dfi-cont">${diffuserDescription}</div>
        <div class="meta-price-flex">
          <p>COLOR: ${selectedVariantTitle}</p><p>${price}</p>
        </div>
      `;

      diffuserSummaryItem.classList.add('is-selected');
      selectedDiffuserPrice   = parseFloat(price.replace(/[^0-9.]/g, ''));
      selectedDiffuserVariant = selectedVariantId;
      selectedDiffuserVariantTitle = selectedVariantTitle;

      gtag('event', 'select_item', {
        items: [{
          item_name: diffuserItem.dataset.title,
          item_category: 'Diffuser',
          price: selectedDiffuserPrice,
          quantity: 1
        }]
      });

      updateBundleCount();
      updateAddToCartState();
      updateBundlePreview();
      updateTotalKitPrice();
      updateProgressBar();
    });
  });

  // ── Remove diffuser ────────────────────────────────────
  diffuserSummaryItem.querySelector('.summary-remove')
    .addEventListener('click', function () {
      selectedDiffuserVariant      = null;
      selectedDiffuserVariantTitle = null;
      diffuserConfirmed            = false;
      nextStepBtn.disabled         = true;
      isAddingToCart               = false;
      selectedDiffuserPrice        = 0;

      diffuserContent.innerHTML = `<p class="placeholder">Select your Diffuser</p>`;
      diffuserMeta.innerHTML    = '';
      diffuserSummaryItem.classList.remove('is-selected');

      document.querySelectorAll('.diffuser-item').forEach(item => item.classList.remove('is-dselected')); // ← add this

      document.querySelectorAll('.variant-swatches .swatch').forEach(s => s.classList.remove('active'));
      document.querySelectorAll('.diffuser-add-btn').forEach(btn => {
        if (!btn.classList.contains('is-soldout')) {
          btn.classList.remove('is-selected');
          btn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1629/7465/files/Button.svg?v=1779944609">`;
          btn.disabled  = false;
        }
      });

      const totalWrap = document.querySelector('.total-kit-price');
      if (totalWrap) totalWrap.style.display = 'none';

      autoSelectFirstDiffuserSwatch();
      updateBundleCount();
      updateAddToCartState();
      updateBundlePreview();
      updateProgressBar();
      enforceStarterBundleGift();
    });

  // ── Scent select ───────────────────────────────────────
  document.querySelectorAll('.scent-item .button').forEach(btn => {
    btn.addEventListener('click', function () {
      const scentItem = this.closest('.scent-item');
      selectedScentVariant     = scentItem.querySelector('.scent-variant-id').value;
      selectedScentSellingPlan = this.dataset.sellingPlanId || null;

      const scentPrice     = this.dataset.price;
      const scentNotes     = this.dataset.scentNotes || '';
      const priceNumber    = parseFloat(scentPrice.replace(/[^0-9.]/g, ''));
      const discountedPrice = (priceNumber * 0.8).toFixed(2);

      const refillPricing = document.querySelector('.Refill-pricing');
      if (refillPricing) {
        refillPricing.innerHTML = `
          <span class="price">$${discountedPrice}</span>
          <span class="compare-at">$${priceNumber.toFixed(2)}</span>
        `;
      }

      document.querySelectorAll('.scent-item').forEach(item => item.classList.remove('active'));
      scentItem.classList.add('active');

      const ratingHtml = scentItem.querySelector('.rating-badge')?.outerHTML || '';

      scentContent.innerHTML = `<img src="${this.dataset.image}" alt="">`;
      scentMeta.innerHTML = `
        <h4>${this.dataset.title}</h4>
        ${ratingHtml}
        <div class="new-flex-div"><p>Free</p><p class="compare">${scentPrice}</p></div>
        <p class="scet-not">${scentNotes}</p>
      `;
      scentSummaryItem.classList.add('is-selected');

      document.querySelectorAll('.scent-item .button').forEach(b => {
        if (!b.classList.contains('is-soldout')) {
          b.classList.remove('is-selected');
          b.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1629/7465/files/Button.svg?v=1779944609">`;
        }
      });

      if (!this.classList.contains('is-soldout')) {
        this.classList.add('is-selected');
        this.textContent = 'Selected';
      }

      selectedScentPrice = priceNumber;

      gtag('event', 'select_item', {
        items: [{
          item_name: this.dataset.title,
          item_category: 'Scent',
          price: 0,
          quantity: 1
        }]
      });

      updateBundleCount();
      updateAddToCartState();
      updateBundlePreview();
      updateTotalKitPrice();
      updateProgressBar();
      setStep(2);
    });
  });

  // ── Remove scent ───────────────────────────────────────
  scentSummaryItem.querySelector('.summary-remove')
    .addEventListener('click', function () {
      selectedScentVariant     = null;
      selectedScentSellingPlan = null;
      isAddingToCart           = false;
      selectedScentPrice       = 0;

      const refillPricing = document.querySelector('.Refill-pricing');
      if (refillPricing) refillPricing.innerHTML = '';

      scentContent.innerHTML = `<p class="placeholder">Select your Scent</p>`;
      scentMeta.innerHTML    = '';
      scentSummaryItem.classList.remove('is-selected');

      document.querySelectorAll('.scent-item').forEach(item => item.classList.remove('active'));
      document.querySelectorAll('.scent-item .button').forEach(b => {
        if (!b.classList.contains('is-soldout')) {
          b.classList.remove('is-selected');
          b.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1629/7465/files/Button.svg?v=1779944609">`;
        }
      });

      const totalWrap = document.querySelector('.total-kit-price');
      if (totalWrap) totalWrap.style.display = 'none';

      updateBundleCount();
      updateAddToCartState();
      updateBundlePreview();
      enforceStarterBundleGift();
      updateProgressBar();
    });

  // ── Add to cart ────────────────────────────────────────
  addToCartBtn.addEventListener('click', function () {
    if (isAddingToCart) return;

    isAddingToCart = true;
    this.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: Number(selectedDiffuserVariant),
            quantity: 1,
            properties: { _starter_bundle: 'true', _is_diffuser: 'true' }
          },
          {
            id: Number(selectedScentVariant),
            quantity: 1,
            selling_plan: selectedScentSellingPlan ? Number(selectedScentSellingPlan) : undefined,
            properties: { _starter_bundle: 'true', _free_scent: 'Starter Kit' }
          }
        ]
      })
    })
    .then(async res => {
      const data = await res.json();
      if (!res.ok) throw data;
    })
    .then(async () => {
      await enforceStarterBundleGift();

      document.addEventListener('cart:refresh', () => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.setAttribute('open', '');
          }
        }
      }, { once: true });

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      gtag('event', 'add_to_cart', {
        currency: 'USD',
        value: selectedDiffuserPrice + selectedScentPrice,
        items: [
          { item_id: selectedDiffuserVariant, item_name: 'Starter Kit', price: selectedDiffuserPrice, quantity: 1 },
          { item_id: selectedScentVariant,    item_name: 'Starter Kit', price: selectedScentPrice,    quantity: 1 }
        ]
      });
    })
    .catch(err => {
      console.error('CART ERROR:', err);
      alert(err.description || 'Add to cart failed');
    })
    .finally(() => {
      isAddingToCart = false;
      addToCartBtn.classList.remove('loading');
    });
  });

  document.addEventListener('cart:refresh', enforceStarterBundleGift);

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (
      target.closest('.rebuy-cart__flyout-item-remove') ||
      target.closest('.rebuy-cart__flyout-item-quantity-widget-button')
    ) {
      setTimeout(enforceStarterBundleGift, 500);
    }
  });
});